import { module } from 'angular';
import { baseModuleId } from '../common/constants/base-module-id';
import { SyncModelDirective } from './sync-model.directive';
export var SyncModelComponentNgModule = module(baseModuleId + ".sync-model", [])
    .directive('syncModel', SyncModelDirective);
